import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/apiConfig';
import './MobileAddPlayer.css';

const MobileAddPlayer = () => {
  const navigate = useNavigate();
  const { zone } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    gender: '',
    organization: '',
    level: '',
    notes: '',
    zone: zone || ''
  });

  useEffect(() => {
    console.log('MobileAddPlayer组件已挂载，区域参数:', zone);
    
    if (!zone) {
      console.warn('区域参数缺失，可能影响球员创建功能');
    }
  }, [zone]);

  const handleBack = () => {
    console.log('返回按钮点击');
    navigate(-1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('提交表单，当前数据:', formData);
    
    if (!formData.name || !formData.gender) {
      alert('请填写必填项');
      return;
    }

    if (!zone) {
      alert('缺少区域参数');
      return;
    }

    try {
      setLoading(true);
      const baseUrl = getApiBaseUrl();
      console.log('正在发送请求到:', `${baseUrl}/api/${zone}/players`);
      
      const response = await axios.post(`${baseUrl}/api/${zone}/players`, {
        ...formData,
        zone
      });
      
      console.log('请求响应:', response.data);
      
      if (response.data.success) {
        alert('添加成功');
        navigate(-1);
      }
    } catch (error) {
      console.error('添加球员失败:', error);
      alert(error.response?.data?.message || '添加失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mobile-add-player">
      {/* 导航栏 */}
      <div className="nav-bar">
        <div className="nav-back" onClick={handleBack}>
          <LeftOutlined className="nav-back-icon" />
        </div>
        <div className="nav-title">添加球员</div>
        <div className="nav-actions"></div>
      </div>

      {/* 表单 */}
      <form className="add-player-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="required">姓名</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="请输入姓名"
            required
          />
        </div>

        <div className="form-group">
          <label className="required">性别</label>
          <div className="radio-group">
            <label className="radio-label">
              <input
                type="radio"
                name="gender"
                value="MALE"
                checked={formData.gender === 'MALE'}
                onChange={handleChange}
              />
              <span>男</span>
            </label>
            <label className="radio-label">
              <input
                type="radio"
                name="gender"
                value="FEMALE"
                checked={formData.gender === 'FEMALE'}
                onChange={handleChange}
              />
              <span>女</span>
            </label>
          </div>
        </div>

        <div className="form-group">
          <label>组织</label>
          <input
            type="text"
            name="organization"
            value={formData.organization}
            onChange={handleChange}
            placeholder="请输入组织名称（选填）"
          />
        </div>

        <div className="form-group">
          <label>水平</label>
          <select
            name="level"
            value={formData.level}
            onChange={handleChange}
          >
            <option value="">请选择水平（选填）</option>
            <option value="初级">初级</option>
            <option value="中级">中级</option>
            <option value="高级">高级</option>
            <option value="专业">专业</option>
          </select>
        </div>

        <div className="form-group">
          <label>备注</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            placeholder="请输入备注（选填）"
            rows="3"
          />
        </div>

        <button 
          type="submit" 
          className="submit-button"
          disabled={loading}
        >
          {loading ? '添加中...' : '添加'}
        </button>
      </form>
    </div>
  );
};

export default MobileAddPlayer;
